const Theme = {
  body_background_color: '#EB212E',

  logo_image_url: 'destinationrennes.png',
  logo_height: 120,

  token_hidden_tokenIds: [0],

  number_font: `'SF UI Display', 'Arial', sans-serif`,
  number_hidden_tokenIds: [0],
  number_weight: 600,

  card_header_margin_top: 20,

  header_background_color: '#EB212E',
  header_border_color: '#eee',

  button_color: '#EB212E',
  button_radius: 50,
  button_font: `'SF UI Display', 'Arial', sans-serif`,
  button_padding: '12px 24px',

  title_font: `'Mohave', 'Montserrat', sans-serif`,
  title_weight: 500,
  title_size: 40,
  title_lineheight: 44,

  subtitle_font: `'SF UI Display', 'Arial', sans-serif`,
  subtitle_size: 30,
  subtitle_lineheight: 34,
  subtitle_weight: 500,

  text_font: `'SF UI Display', 'Arial', sans-serif`,
  text_size: 16,
  text_lineheight: 25.6,

  footer_border_color: '#eee',
}

export default Theme
